import { WinPopUp, WinPopUpParams } from './WinPopUp';
import { createButton, createSprite, showSorryNoAd, translate } from '../../utils/GameEngine';
import { TextStyles } from '../../utils/TextStyles';
import Sprite = PIXI.Sprite;
import Text = PIXI.Text;
import { TextIncrement } from '../../UI/elements/TextIncrement';
import { AdButtonLarge } from '../../UI/elements/buttons/AdButtonLarge';
import { AdButton } from '../../UI/elements/buttons/AdButton';

export interface LevelWinPopupParams extends WinPopUpParams {
    levelIndex: number;
    levelScore: number;
    bonusScore: number;
    totalScore: number;
    double: boolean;
}

export class LevelWinPopup extends WinPopUp {
    protected doubleButton: AdButtonLarge | AdButton;

    protected drawLayout(params?: any): void {
        super.drawLayout(params);
        this.background.cacheAsBitmap = false;
        this.addTitle();
        this.background.cacheAsBitmap = true;
        this.drawScoreTexts();
        this.addContinueButton();
    }

    private addTitle(): void {
        const titleBG: Sprite = createSprite('popup_level_bg', this.background);
        titleBG.anchor.set(0.5, 0.5);
        titleBG.position.set(this.imageBox.x + this.imageBox.width / 2, titleBG.height / 2);
        const levelText: Text = new Text(translate('level'), TextStyles.smallTextWhite);
        levelText.anchor.set(0.5, 0.5);
        levelText.position.set(titleBG.x, titleBG.y - titleBG.height / 2 + 16);
        this.background.addChild(levelText);
        const levelNumberText: Text = new Text('' + (this.params as LevelWinPopupParams).levelIndex, TextStyles.counterText);
        levelNumberText.anchor.set(0.5, 0.5);
        levelNumberText.position.set(titleBG.x, titleBG.y);
        this.background.addChild(levelNumberText);
    }

    private drawScoreTexts(): void {
        const labelX: number = this.textBox.x + Math.floor(this.textBox.width * 0.55);
        const textX: number = this.textBox.x + this.textBox.width - 32;
        const levelY: number = 180;
        const movesY: number = 230;
        const totalY: number = 280;
        const coinsY: number = 330;

        const levelScoreLabel: Text = new PIXI.Text(translate('level score') + ':', TextStyles.winPopupLabel);
        levelScoreLabel.anchor.set(1, 0.5);
        levelScoreLabel.position.set(labelX, levelY);
        this.addChild(levelScoreLabel);

        const movesBonusLabel: Text = new PIXI.Text(translate('moves bonus') + ':', TextStyles.winPopupLabel);
        movesBonusLabel.anchor.set(1, 0.5);
        movesBonusLabel.position.set(labelX, movesY);
        this.addChild(movesBonusLabel);

        const totalScoreLabel: Text = new PIXI.Text(translate('total score') + ':', TextStyles.winPopupLabel);
        totalScoreLabel.anchor.set(1, 0.5);
        totalScoreLabel.position.set(labelX, totalY);
        this.addChild(totalScoreLabel);

        const coinsLabel: Text = new PIXI.Text(translate('coins') + ':', TextStyles.winPopupLabel);
        coinsLabel.anchor.set(1, 0.5);
        coinsLabel.position.set(labelX, coinsY);
        this.addChild(coinsLabel);

        const levelScore: TextIncrement = new TextIncrement(
            null,
            '',
            '',
            TextStyles.winPopupText,
            this,
            false,
            (this.params as LevelWinPopupParams).levelScore,
            true
        );
        levelScore.anchor.set(1, 0.5);
        levelScore.position.set(textX, levelY);

        const movesBonus: TextIncrement = new TextIncrement(
            null,
            '+',
            '',
            TextStyles.winPopupText,
            this,
            false,
            (this.params as LevelWinPopupParams).bonusScore,
            true
        );
        movesBonus.anchor.set(1, 0.5);
        movesBonus.position.set(textX, movesY);

        const totalScore: TextIncrement = new TextIncrement(
            null,
            '',
            '',
            TextStyles.winPopupTextTotal,
            this,
            true,
            (this.params as LevelWinPopupParams).totalScore,
            true
        );
        totalScore.anchor.set(1, 0.5);
        totalScore.position.set(textX, totalY);

        const coinsSprite: Sprite = createSprite('popup_coins_icon', this);
        coinsSprite.anchor.set(0, 0.5);
        coinsSprite.position.set(textX + 6, coinsY);

        this.increments = [];
    }

    private addContinueButton(): void {
        this.continueButton = createButton(
            'green_btn_large@2x',
            this,
            (): void => {
                this.hide();
            },
            translate('Continue', true),
            true,
            true,
            1
        );
        let buttonX: number = this.background.width / 2;
        if (this.doubleButton) {
            buttonX = 566;
        }
        this.continueButton.position.set(buttonX, this.buttonY);
    }

    public destroy(options?: any): void {
        if (this.doubleButton) {
            this.doubleButton.destroy();
        }
        super.destroy(options);
    }
}